<template>
  <h2 class="screen_out">검색결과</h2>
  <article
    id="mainContent"
    class="content-article content_search"
  >
    <div class="wrap_search">
      <div class="area_form">
        <FormTotalSearch :type="'page'" />
      </div>
      <div class="area_result">
        <AreaCategorySearchPc
          v-if="isWidthStore.resolutionList.isPc"
          :lengthResult="lengthResult"
          :type="'result'"
          :searchData="searchData"
          class="section_search type_search"
          @doSearch="doSearch"
        />
        <AreaCategorySearchMo
          v-else
          :type="'result'"
          :searchData="searchData"
          class="section_search type_search"
          @doSearch="doSearch"
        />
        <section class="section_search type_list">
          <h3 class="screen_out">검색결과</h3>
          <template v-if="lengthResult > 0">
            <template
              v-for="(item, idx) in [
                { data: serviceList, type: 'top', contentType: 'service' },
                { data: caseList, type: 'top', contentType: 'case' },
                { data: newsList, type: 'top', contentType: 'news' },
                { data: downloadList, type: 'top', contentType: '' },
                { data: bottomList, type: 'bottom', contentType: 'etc' },
              ]"
            >
              <ListSearch
                v-if="item.data.list.length > 0"
                :key="`${idx}_list`"
                :listData="item.data"
                :type="item.type"
                :contentType="item.contentType"
              />
            </template>
          </template>
          <div
            v-else
            class="wrap_nolist"
          >
            <span>등록된 콘텐츠가 없습니다.</span>
          </div>
          <div
            v-if="isMoreData"
            class="wrap_more"
          >
            <button
              type="button"
              @click="doMoreSearch"
            >
              전체보기
            </button>
          </div>
        </section>
      </div>
    </div>
  </article>
</template>
<script setup>
import { fetchSearchList } from '/api/admin';
import { useIsWidth, useTotalSearchKeyword } from '/stores/store';
import { useApi } from 'daco-common-nuxt3';
import { errorCatchHandlerCommon } from '/composables/error';
const isWidthStore = useIsWidth();
const totalSearchKeyword = useTotalSearchKeyword();
// 검색영역에서 가져오는 값
const searchData = ref({
  dataSort: {
    name: '전체',
    isSelected: true,
    data: '',
  },
  isMoreList: true,
});
const ROW_LENGTH = ref(10);
const moreCheckNum = 10;
const lengthResult = ref(0);
const isMoreData = computed(() => {
  return ROW_LENGTH.value === moreCheckNum && lengthResult.value > moreCheckNum;
});

const serviceList = ref({
  name: '서비스',
  contentLength: 0,
  list: [],
});
const caseList = ref({
  name: '고객사례',
  contentLength: 0,
  list: [],
});
const newsList = ref({
  name: '뉴스',
  contentLength: 0,
  list: [],
});
const downloadList = ref({
  name: '자료실',
  contentLength: 0,
  list: [],
});
const bottomList = ref({
  name: '기타',
  contentLength: 0,
  list: [],
});

const route = useRoute();
const router = useRouter();
const isLoaded = ref(false);
//페이지 진입시 쿼리값 가져와서 공통 검색값 변경한다.
totalSearchKeyword.setTotalSearchKeyword(route.query.searchKeyword);

const fetchData = () => {
  return fetchSearchList(
    searchData.value.dataSort.data,
    totalSearchKeyword.searchWord,
    ROW_LENGTH.value,
  );
};

const setDataList = (data) => {
  serviceList.value.list = [...data.serviceList];
  caseList.value.list = [...data.parnterCaseList];
  newsList.value.list = [...data.newsList];
  downloadList.value.list = [...data.informationList];
  bottomList.value.list = [...data.list];

  lengthResult.value = data.search.totalRecordCount;
  serviceList.value.contentLength = data.search.serviceCount;
  caseList.value.contentLength = data.search.partnerCaseCount;
  newsList.value.contentLength = data.search.newsCount;
  downloadList.value.contentLength = data.search.informationCount;
};

//검색데이터 변경시 검색실행 할 부분
const doSearch = () => {
  ROW_LENGTH.value = 10; //초기화

  useApi(
    'searchData',
    () => {
      //조건검색시
      return fetchData()
        .then((data) => {
          setDataList(data);
          scrollTop();
        })
        .catch(errorCatchHandlerCommon);
    },
    {},
  );
};

const doMoreSearch = () => {
  if (route.query.page !== 'all') {
    router.push(`/search?searchKeyword=${totalSearchKeyword.searchWord}&page=all`);
    return;
  }
  //전체검색결과수
  ROW_LENGTH.value = 10000; //전체보기

  useApi(
    'searchData',
    () => {
      //전체보기 클릭시
      return fetchData()
        .then((data) => {
          setDataList(data);
          isLoaded.value = true;
        })
        .catch(errorCatchHandlerCommon);
    },
    {},
  );
};
watch(
  () => route.query.searchKeyword, //인풋값 변경시마다 활성화
  () => {
    //값변경시 실행
    //쿼리 변경시 공통 검색값을 변경해준다.
    totalSearchKeyword.setTotalSearchKeyword(route.query.searchKeyword);
    if (route.query.page === 'all') {
      doMoreSearch();
    } else {
      doSearch();
    }
  },
  { deep: true, immediate: true },
);

useHead({
  meta: [
    {
      name: 'description',
      content: `'${totalSearchKeyword.searchWord}' 검색결과 입니다.`,
    },
    {
      property: 'og:description',
      content: `'${totalSearchKeyword.searchWord}' 검색결과 입니다.`,
    },
  ],
});
</script>
<style lang="scss" scoped>
.content_search {
  padding: 50px 128px 120px;
}
.area_form {
  width: 1040px;
  margin: 0 auto 150px;
}
.area_result {
  display: flex;
  justify-content: space-between;
  max-width: 1664px;
  margin: 0 auto;
}
.section_search {
  &.type_search {
    position: sticky;
    top: 153px;
    margin-right: 140px;
    flex-shrink: 0;
  }
  &.type_list {
    flex-grow: 1;
    margin: 0 auto;
  }
}
.wrap_nolist {
  position: relative;
  height: 100%;
  text-align: center;
  color: #999;
  font-size: 18px;
  span {
    position: absolute;
    width: 100%;
    text-align: center;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.wrap_more {
  margin-top: 60px;
  text-align: center;
  button {
    padding: 8px 28px 8px 12px;
    font-size: 16px;
    color: #5887ff;
    @include backgroundImage(
      "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='17' height='16' fill='none'%3E%3Cpath d='m3.5 5 5 5 5-5' stroke='%235887FF' stroke-width='1.5'/%3E%3C/svg%3E",
      16px 16px,
      top 12px right 8px
    );
  }
}
@media screen and (max-width: 1439px) {
  .content_search {
    padding: 72px 80px 120px;
  }
  .area_form {
    width: 864px;
  }
  .section_search {
    &.type_search {
      margin-right: 64px;
    }
  }
}
@media screen and (max-width: 1023px) {
  .content_search {
    padding: 24px 40px 80px;
  }
  .area_form {
    width: 100%;
    margin: 0 auto 60px;
  }
  .tit_search {
    margin: 52px 0 24px 0;
    font-size: 24px;
    line-height: 42px;
  }
  .section_search {
    &.type_search {
      position: fixed;
      top: 0;
    }
  }
  .wrap_nolist {
    height: calc(100vh - 322px);
  }
}
@media screen and (max-width: 811px) {
  .content_search {
    padding: 0 20px 80px;
  }
  .tit_search {
    margin: 25px 0 24px 0;
    line-height: 36px;
  }
  .wrap_nolist {
    height: calc(100vh - 322px);
  }
  .wrap_more {
    margin-top: 40px;
  }
}
</style>
